import { definitionsFromGlob } from 'stimulus-vite-helpers';
import { registerComponentsBase } from 'turbo-mount';

const registerComponents = ({ plugin, turboMount, components, controllers, }) => {
    return registerComponentsBase({
        plugin,
        turboMount,
        components: Object.entries(components).map(([filename, module]) => ({
            filename,
            module,
        })),
        controllers: controllers ? definitionsFromGlob(controllers) : [],
    });
};

export { registerComponents };
